import { useEffect, useState } from 'react';
import { useEventBus } from '../../../../../hooks/use-event-bus';
import {
  EventIvShowApptRequestVerificationDialog,
  EventIvShowNoAppRequestInsuranceDialog
} from '../../../../../types/event-bus';
import { ApptRequestIvDialogSelector } from '../../status-dialog/appt-request-iv-status-dialog-selector';
import VerificationUnknownDialog from '../../status-dialog/unknown-patient-status/unknown-patient-status-dialog';
import VerificationInProcessDialog from '../../status-dialog/verification-in-process/verification-in-process-dialog';
import { ApptRequestIvContext } from './context';

export const ApptRequestIvProvider = (props: any) => {
  const { listen } = useEventBus();
  const [knownInsuranceEvent, setKnownInsuranceEvent] = useState<EventIvShowApptRequestVerificationDialog>();
  const [unknownInsuranceEvent, setUnknownInsuranceEvent] = useState<EventIvShowNoAppRequestInsuranceDialog>();
  const [ivDialogOpened, setIvDialogOpened] = useState(false);

  useEffect(() => {
    const listener1 = listen('ivShowApptRequestVerificationDialog', (event) => {
      resetAllEvents();
      setKnownInsuranceEvent(event as EventIvShowApptRequestVerificationDialog);
      setIvDialogOpened(true);
    });

    const listener2 = listen('ivShowNoApptRequestInsuranceDialog', (event) => {
      resetAllEvents();
      setUnknownInsuranceEvent(event as EventIvShowNoAppRequestInsuranceDialog);
      setIvDialogOpened(true);
    });

    return () => {
      listener1();
      listener2();
    };
  }, []);

  const handleIvDialogClose = () => {
    setIvDialogOpened(false);
    resetAllEvents();
  };

  const resetAllEvents = () => {
    setKnownInsuranceEvent(undefined);
    setUnknownInsuranceEvent(undefined);
  };

  return (
    <ApptRequestIvContext.Provider value={null!}>
      {props.children}
      {unknownInsuranceEvent &&
        (unknownInsuranceEvent.data.isUnknown ? (
          <VerificationUnknownDialog
            opened={ivDialogOpened}
            onClose={handleIvDialogClose}
            locationId={unknownInsuranceEvent.data.locationId}
            appointmentRequestId={unknownInsuranceEvent.data.apptRequestId}
          />
        ) : (
          <VerificationInProcessDialog
            opened={ivDialogOpened}
            onClose={handleIvDialogClose}
            locationId={unknownInsuranceEvent.data.locationId}
            appointmentRequestId={unknownInsuranceEvent.data.apptRequestId}
          />
        ))}

      {knownInsuranceEvent && (
        <ApptRequestIvDialogSelector
          opened={ivDialogOpened}
          insuranceEvent={knownInsuranceEvent}
          onClose={handleIvDialogClose}
        />
      )}
    </ApptRequestIvContext.Provider>
  );
};
